import { render } from "./OidoIcon.vue?vue&type=template&id=25e0aed7"
import script from "./OidoIcon.vue?vue&type=script&lang=js"
export * from "./OidoIcon.vue?vue&type=script&lang=js"

import "./OidoIcon.vue?vue&type=style&index=0&id=25e0aed7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__